import { render, staticRenderFns } from "./SaleingRatePlan.vue?vue&type=template&id=63330f17"
import script from "./SaleingRatePlan.vue?vue&type=script&lang=js"
export * from "./SaleingRatePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports